import React from "react";
import { connect } from "react-redux";
import {
  getCurrentStoreData,
  savePartialWebsiteData,
} from "../../../store/websites/thunks";
import {
  changeWebsiteItemGlobalData,
  changeWebsitesStateGlobalData,
  editCustomStyles,
} from "../../../store/websites/actions";
import _ from "lodash";
import Item from "./components/Item";
import { StyleMenuProps } from "./components/types";
import "./StyleMenu.scss";

const Example = (): JSX.Element => {
  return (
    <div className="comps">
      <div
        className="style-blue-1 checkered-bg checkered-bg--no-hover has-opacity style-menu__preview"
        style={{
          margin: "0 8px",
          padding: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: 350,
        }}
      >
        <div className="vert-space-example" style={{zIndex: 100, maxWidth: 200, transform: "scale(0.8)"}}>
          <div className="space-example-card"></div>
          <div className="space-example-card"></div>
        </div>
      </div>
    </div>
  );
};

const ContainerStyleMenu = (props: StyleMenuProps): JSX.Element => {
  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <Example />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "0 8px" }}>
        <Item
          inputType="number"
          placeholder="0"
          customStyleProperty="additionalVerticalSpace"
          // tooltip="Add extra vertical space between page components."
          presets={[
            { value: "0", description: "Default" },
            { value: "64", description: "Medium" },
            { value: "128", description: "Large" },
          ]}
          {...props}
        >
          Extra vertical space
        </Item>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    websites: state.websites,
  };
};
export default connect(mapStateToProps, {
  getCurrentStoreData,
  editCustomStyles,
  savePartialWebsiteData,
  changeWebsitesStateGlobalData,
  changeWebsiteItemGlobalData,
})(ContainerStyleMenu);
